// Country → list of major cities for the freelancer signup form.
export const COUNTRIES = [
  ["United States", ["New York", "San Francisco", "Los Angeles", "Chicago", "Seattle", "Austin", "Boston", "Miami", "Denver", "Atlanta"]],
  ["Canada", ["Toronto", "Vancouver", "Montreal", "Calgary", "Ottawa", "Edmonton", "Quebec City"]],
  ["United Kingdom", ["London", "Manchester", "Edinburgh", "Birmingham", "Glasgow", "Bristol", "Leeds"]],
  ["Germany", ["Berlin", "Munich", "Hamburg", "Frankfurt", "Cologne", "Stuttgart", "Düsseldorf"]],
  ["France", ["Paris", "Lyon", "Marseille", "Toulouse", "Nice", "Nantes", "Strasbourg"]],
  ["Spain", ["Madrid", "Barcelona", "Valencia", "Seville", "Bilbao", "Málaga"]],
  ["Italy", ["Rome", "Milan", "Naples", "Turin", "Florence", "Bologna"]],
  ["Netherlands", ["Amsterdam", "Rotterdam", "The Hague", "Utrecht", "Eindhoven"]],
  ["Sweden", ["Stockholm", "Gothenburg", "Malmö", "Uppsala"]],
  ["Norway", ["Oslo", "Bergen", "Trondheim", "Stavanger"]],
  ["Denmark", ["Copenhagen", "Aarhus", "Odense", "Aalborg"]],
  ["Finland", ["Helsinki", "Espoo", "Tampere", "Oulu"]],
  ["Ireland", ["Dublin", "Cork", "Galway", "Limerick"]],
  ["Portugal", ["Lisbon", "Porto", "Braga", "Coimbra"]],
  ["Switzerland", ["Zurich", "Geneva", "Basel", "Bern", "Lausanne"]],
  ["Austria", ["Vienna", "Graz", "Linz", "Salzburg"]],
  ["Belgium", ["Brussels", "Antwerp", "Ghent", "Bruges"]],
  ["Poland", ["Warsaw", "Krakow", "Wroclaw", "Poznań", "Gdańsk"]],
  ["Czech Republic", ["Prague", "Brno", "Ostrava", "Plzeň"]],
  ["Greece", ["Athens", "Thessaloniki", "Patras", "Heraklion"]],
  ["Romania", ["Bucharest", "Cluj-Napoca", "Timișoara", "Iași"]],
  ["Russia", ["Moscow", "Saint Petersburg", "Novosibirsk", "Yekaterinburg"]],
  ["Turkey", ["Istanbul", "Ankara", "Izmir", "Bursa", "Antalya"]],
  ["Ukraine", ["Kyiv", "Lviv", "Kharkiv", "Odesa"]],
  ["Israel", ["Tel Aviv", "Jerusalem", "Haifa", "Beersheba"]],
  ["UAE", ["Dubai", "Abu Dhabi", "Sharjah", "Ajman"]],
  ["Saudi Arabia", ["Riyadh", "Jeddah", "Mecca", "Dammam"]],
  ["Egypt", ["Cairo", "Alexandria", "Giza", "Sharm El Sheikh"]],
  ["South Africa", ["Johannesburg", "Cape Town", "Durban", "Pretoria"]],
  ["Nigeria", ["Lagos", "Abuja", "Kano", "Ibadan"]],
  ["Kenya", ["Nairobi", "Mombasa", "Kisumu", "Nakuru"]],
  ["India", ["Bengaluru", "Mumbai", "Delhi", "Hyderabad", "Chennai", "Pune", "Kolkata", "Ahmedabad", "Gurugram", "Noida"]],
  ["Pakistan", ["Karachi", "Lahore", "Islamabad", "Rawalpindi"]],
  ["Bangladesh", ["Dhaka", "Chittagong", "Sylhet"]],
  ["Sri Lanka", ["Colombo", "Kandy", "Galle"]],
  ["China", ["Beijing", "Shanghai", "Shenzhen", "Guangzhou", "Chengdu", "Hangzhou"]],
  ["Japan", ["Tokyo", "Osaka", "Kyoto", "Yokohama", "Fukuoka", "Sapporo"]],
  ["South Korea", ["Seoul", "Busan", "Incheon", "Daegu"]],
  ["Singapore", ["Singapore"]],
  ["Malaysia", ["Kuala Lumpur", "George Town", "Johor Bahru", "Ipoh"]],
  ["Indonesia", ["Jakarta", "Surabaya", "Bandung", "Medan", "Bali"]],
  ["Thailand", ["Bangkok", "Chiang Mai", "Phuket", "Pattaya"]],
  ["Vietnam", ["Ho Chi Minh City", "Hanoi", "Da Nang"]],
  ["Philippines", ["Manila", "Quezon City", "Cebu", "Davao"]],
  ["Australia", ["Sydney", "Melbourne", "Brisbane", "Perth", "Adelaide", "Canberra"]],
  ["New Zealand", ["Auckland", "Wellington", "Christchurch", "Hamilton"]],
  ["Brazil", ["São Paulo", "Rio de Janeiro", "Brasília", "Salvador", "Fortaleza"]],
  ["Argentina", ["Buenos Aires", "Córdoba", "Rosario", "Mendoza"]],
  ["Chile", ["Santiago", "Valparaíso", "Concepción"]],
  ["Mexico", ["Mexico City", "Guadalajara", "Monterrey", "Puebla", "Tijuana"]],
  ["Colombia", ["Bogotá", "Medellín", "Cali", "Barranquilla"]],
];

export const LANGUAGES = [
  "English", "Mandarin Chinese", "Spanish", "Hindi", "Arabic", "Bengali", "Portuguese", "Russian",
  "Japanese", "Punjabi", "German", "Korean", "French", "Turkish", "Vietnamese", "Italian", "Polish",
  "Ukrainian", "Persian", "Dutch", "Greek", "Czech", "Swedish", "Romanian", "Hungarian", "Hebrew",
  "Thai", "Indonesian", "Malay", "Tagalog", "Urdu", "Tamil", "Telugu", "Marathi", "Gujarati",
];

export const DEVICE_TYPES = ["iOS", "Android", "Desktop / Laptop", "Tablet", "Other"];

export const MANUFACTURERS = [
  "Apple", "Samsung", "Google", "Xiaomi", "OnePlus", "Huawei", "Oppo", "Vivo", "Sony", "Nokia",
  "Motorola", "Dell", "HP", "Lenovo", "Asus", "Acer", "Microsoft", "MSI", "Razer", "Other",
];

export const OS_VERSIONS = [
  "iOS 17", "iOS 18", "Android 13", "Android 14", "Android 15",
  "macOS 13 Ventura", "macOS 14 Sonoma", "macOS 15 Sequoia",
  "Windows 10", "Windows 11", "Ubuntu 22.04", "Ubuntu 24.04", "ChromeOS", "Other",
];

export const ADDITIONAL_DEVICES = [
  "Smart TV (Samsung Tizen)", "Smart TV (LG webOS)", "Smart TV (Android TV)", "Apple TV",
  "Fire TV", "Roku", "Chromecast",
  "Apple Watch", "Wear OS smartwatch", "Fitbit",
  "VR Headset (Meta Quest)", "VR Headset (Apple Vision Pro)", "Gaming console (PlayStation)",
  "Gaming console (Xbox)", "Nintendo Switch",
  "Smart Speaker (Alexa)", "Smart Speaker (Google Home)", "Smart Speaker (HomePod)",
  "Smart home hub", "Connected car infotainment", "IoT sensor / smart appliance", "Other",
];

export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const TIME_SLOTS = [
  "Not available",
  "00:00 - 04:00", "04:00 - 08:00", "08:00 - 12:00",
  "12:00 - 16:00", "16:00 - 20:00", "20:00 - 24:00",
  "Full day (flexible)",
];
